import React, { useEffect, useState } from 'react';
import axios from '../axiosConfig';
import { handleError, toastError, toastErrorUniqueInfinite, toastSuccess } from '../funciones.js';
import Filtros from './Filtros.js';
import Modal from './Modal';
import ModalPerfil from './ModalPerfil';
import Paginacion from './Paginacion';
import logoInscriptos from '../assets/logoInscriptos.png';
import logoEliminar from '../assets/logoEliminar.png';
import logoEditar from '../assets/logoEditar.png';
import logoAprobar from '../assets/logoAprobar.png';
import logoVerPerfil from '../assets/logoVerPerfil.png';
import logoDesaprobar from '../assets/logoDesaprobar.png';
import DeseaCancelar from './DeseaCancelar.js';
import ModalExisteCuit from './ModalExisteCuit.js'; 
import { FiltrosAdmin } from './FiltrosAdmin.js';
import { EmpresasInscriptas } from './EmpresasInscriptas.js';
import { toast } from 'react-toastify';
import { LoaderTabla } from './LoaderTabla.js';
import CrearReunion from './CrearReunion.js';
import Imprimir from './Imprimir.js';
import ModalAgregarMesa from './ModalAgregarMesa.jsx';
import { CrearEventoN } from './CrearEventoN.js';
import { ModalCambiarUnion } from './ModalCambiarUnion.js';

function TablaAdmin(props) {

    const [elementos, setElementos] = useState([]);
    const [elementosTotal, setElementosTotal] = useState([]);
    const [empresasRonda, setEmpresasRonda] = useState([]);
    const [mesasRonda, setMesasRonda] = useState([]);
    const [horariosRonda, setHorariosRonda] = useState([]);
    const [idsElemModif, setIdsElemModif] = useState([]);
    const [inscripcion, setInscripcion] = useState({});
    const [empresa, setEmpresa] = useState({});
    const [perfil, setPerfil] = useState({ rubros: [], productosOfrecidos: [], productosDemandados: [], nombre: '' });
    //Filtros aprobarEmpresa
    const [tipoEvaluar, setTipoEvaluar] = useState("0");
    const [tipoMora, setTipoMora] = useState("0");
    const [union, setUnion] = useState("0");
    //Filtros crearReunion
    const [horaInicio, setHoraInicio] = useState("");
    const [empresaId, setEmpresaId] = useState("");
    const [numeroMesa, setNumeroMesa] = useState("");
    const [estadoReunion, setEstadoReunion] = useState("0");
    const [esParaEmpresas, setEsParaEmpresas] = useState(false);

    const [idElemSeleccionado, setIdElemSeleccionado] = useState("");
    const [evento, setEvento] = useState({ nombre: '' });
    const [mostrarLoader, setMostrarLoader] = useState(true);
    const [mostrarMenuImprimir, setMostrarMenuImprimir] = useState(false);
    const itemsFiltro = props.seccion === "aprobarEmpresa" ? [
        {
            setValue: setTipoEvaluar, value: tipoEvaluar, id: "tipoEvaluar", text: "Tipo de evaluación",
            items: ["Todas", "A evaluar", "Aprobadas", "Desaprobadas"]
        },
        {
            setValue: setTipoMora, value: tipoMora, id: "tipoMora", text: "Tipo de mora",
            items: ["Todas", "Con mora", "Sin mora"]
        },
        {
            setValue: setUnion, value: union, id: "uniones", text: "Tipo de unión",
            items: ["Todas", "Con mora", "Sin mora"], mostrarTodas: true, idSeccion: 0
        }
    ] : [
        {
            setValue: setEmpresaId, value: empresaId, id: "empresaFiltroId", text: "Empresa",
            items: empresasRonda, idSeccion: 10, initialState: ""
        },
        {
            setValue: setEstadoReunion, value: estadoReunion, id: "estadoFiltro", text: "Estado",
            items: ["Concretadas", "Pendientes", "No concretadas"], mostrarTodas: true,
        },
        {
            setValue: setHoraInicio, value: horaInicio, id: "horarioFiltro", text: "Horario",
            items: horariosRonda, idSeccion: 10, isText: true, initialState: "", disabled: estadoReunion === "1"
        },
        {
            setValue: setNumeroMesa, value: numeroMesa, id: "mesaFiltro", text: "Mesa",
            items: mesasRonda, idSeccion: 10, isText: true, initialState: "", disabled: estadoReunion === "1"
        }
    ];
    //var cantPaginas;
    useEffect(() => {
        props.seccion !== "crearReunion" && cargarElementos();
    }, [])

    useEffect(() => {
        if (props.seccion === "aprobarEmpresa" || props.seccion === "crearEvento") {
            document.getElementById("buscarText").addEventListener("keyup", function () {
                filtrarNombre();
            });
        }
    }, [elementosTotal])

    useEffect(() => {
        if (props.evento !== undefined && props.evento !== null && props.evento.id !== undefined) {
            setEvento(props.evento)
            cargarElementos()
        } else if (props.evento === null || props.evento === undefined || props.evento.id === undefined) {
            setMostrarLoader(false)
        }
    }, [props.evento])
    useEffect(() => {
        if (props.evento !== undefined && props.evento !== null && props.evento.id !== undefined)
            cargarElementos()
    }, [empresaId, estadoReunion, numeroMesa, horaInicio])

    function cargarElementos() {
        var url;
        var paginado = props.seccion === "crearEvento" || props.seccion === 'aprobarEmpresa';
        if (props.seccion === "aprobarEmpresa")
            url = 'empresa/todasLasEmpresas?size=100000';
        else if (props.seccion === "crearEvento")
            url = `evento/todosLosEventos?size=100000`;
        else if (props.seccion === "crearReunion") {
            if (estadoReunion === "1")
                url = 'empresa/reunionesPendientes?eventoId=' + props.evento.id + (empresaId ? "&empresaId=" + empresaId : '')
            else
                url = 'empresa/empresasDeUnaReunion?eventoId=' + props.evento.id + (empresaId ? "&empresaId=" + empresaId : '')
                    + (horaInicio ? "&horaInicio=" + horaInicio.split(" / ")[0] : '') + (numeroMesa ? "&numeroMesa=" + numeroMesa : '')
                    + (estadoReunion === "2" ? "&creada=" + false : '') + (estadoReunion === "0" ? "&creada=" + true : '')
        }/* else {
            url = 'evento/disponiblesParaInscribirseDeUnaEmpresa';
        }*/
        axios
            .get(process.env.REACT_APP_URL + url)
            .then(function (response) {
                setMostrarLoader(false)
                if (paginado) {
                    setElementosTotal(response.data.content);
                    setElementos(response.data.content);
                } else {
                    if (estadoReunion === "1") {
                        const elem = response.data.flatMap((group) =>
                            group.empresasDeInteres.map((empresaInteres) => ({
                                empresa: group.empresa,
                                empresaInteres: empresaInteres,
                            }))
                        );
                        setElementosTotal(elem);
                        setElementos(elem);
                    } else {
                        setElementosTotal(response.data);
                        setElementos(response.data);
                    }
                }
            })
            .catch(function (error) {
                setMostrarLoader(false)
                toastError(handleError(error))
            });

    }
    function mostrarEmpresa(elem) {
        return (tipoEvaluar === "0" || (tipoEvaluar === "1" && elem.estaAprobado === null)
            || (tipoEvaluar === "2" && elem.estaAprobado) || (tipoEvaluar === "3" && elem.estaAprobado === false))
            && (tipoMora === "0" || (tipoMora === "1" && elem.estaEnMora)
                || (tipoMora === "2" && !elem.estaEnMora)) && (union === "0" || union == elem.numeroUnion)
    }

    function filtrarNombre() {
        if (props.seccion !== "crearEvento" || (props.seccion === "crearEvento" &&
            !document.getElementById("containerInscriptos").classList.contains("transform-none")) &&
            !document.getElementById("containerInvitados").classList.contains("transform-none")) {
            const filtro = document.getElementById("buscarText").value;
            if (filtro.localeCompare("") !== 0) {

                setElementos([])
                elementosTotal.map(function (elem) {
                    if (elem.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                        .includes(filtro.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))) {

                        setElementos(elementos => [...elementos, elem])

                    }
                });

            }
            else {
                setElementos(elementosTotal)
            }
        }
    }
    /*function agregarModificado(idElem, idInscripcion) {
        if (idInscripcion !== undefined)
            setIdsElemModif(idsElemModif => [...idsElemModif, { idEmpresa: idElem, idInscripcion: idInscripcion }]);
        else
            setIdsElemModif(idsElemModif => [...idsElemModif, idElem]);
    }
    
    function elementoModificado(idElem, idInscripcion) {
        var ret = false
        idsElemModif.map(function (id) {
            if (idInscripcion !== undefined) {
                if (id.idEmpresa.localeCompare(idElem) === 0 && id.idInscripcion.localeCompare(idInscripcion) === 0) {
                    ret = true;
                }
            }
            else {
                if (id.localeCompare(idElem) === 0) {
                    ret = true;
                }
            }
        });
        return ret;
    }*/
    function modificarMora(empresaId, tipo) {
        const params = {
            params: {
                empresaId: empresaId,
                tipoMora: tipo,
            }
        }
        axios
            .put(process.env.REACT_APP_URL + "empresa/modificarMora", null, params)
            .then((res) => {
                //if(!props.esModificar) 
                cambiarEmpresa(empresaId, tipo, 0);
                if (tipo)
                    toastSuccess("Mora agregada")
                else
                    toastSuccess("Mora removida")

            })
            .catch(function (error) {
                toastError(handleError(error))
            })

    }

    useEffect(() => {
        if (props.seccion === "crearReunion" && props.evento.id !== undefined) {
            const params = {
                params: {
                    eventoId: props.evento.id
                }
            }
            saveAxiosData(setEmpresasRonda, 'empresa/verEmpresasDeUnEvento', params)
            saveAxiosData(setHorariosRonda, 'evento/turnosDeUnEvento', params)
            saveAxiosData(setMesasRonda, 'evento/mesasDeUnEvento', params)
        }
        if (props.seccion === "crearEvento") {
            setEvento(props.evento)
        }
    }, [props.evento])

    useEffect(() => {
        if (props.nombreBuscar == '')
            setElementos(elementosTotal)
    }, [props.nombreBuscar])

    const saveAxiosData = (funcion, url, params) => {
        axios
            .get(process.env.REACT_APP_URL + url, params)
            .then(function (response) {
                funcion(response.data);
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
    }

    function cambiarEmpresa(idEmpresa, valor, tipoModif, numeroUnion) {
        //tipoModif -- 0 = modificarMora, 1 = evaluarUsuario, 2 = cambiarUnion


        setElementos(elementos.map((elem) => {
            if (elem.id.localeCompare(idEmpresa) === 0)
                if (tipoModif === 0)
                    elem.estaEnMora = valor;
                else if (tipoModif === 1)
                    elem.estaAprobado = valor;
                else if (tipoModif === 2) {
                    elem.union = valor;
                    elem.numeroUnion = numeroUnion;
                }
            return elem;
        }));
        setElementosTotal(elementosTotal.map((elem) => {
            if (elem.id.localeCompare(idEmpresa) === 0)
                if (tipoModif === 0)
                    elem.estaEnMora = valor;
                else if (tipoModif === 1)
                    elem.estaAprobado = valor;
                else if (tipoModif === 2) {
                    elem.union = valor;
                    elem.numeroUnion = numeroUnion;
                }
            return elem;
        }));

    }
    function cambiarEvento(id, tipoModif) {
        //tipoModif -- 0 = eliminarEvento, 1 = crearEvento
        if (tipoModif === 0) {
            setElementos(elementos => elementos.filter(item => item.id !== id));
            setElementosTotal(elementosTotal => elementosTotal.filter(item => item.id !== id));
        } else if (tipoModif === 1) {
            cargarElementos();
        }

    }
    function evaluarUsuario(empresaId, tipo, idBoton) {
        const params = {
            params:
            {
                empresaId: empresaId,
                tipo: tipo,
            }
        }
        if (tipo) {
            const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 300000));
            toast.promise(resolveAfter3Sec, { pending: "Enviando notificación" })
            document.getElementById(idBoton).classList.add("pointer-events-none");
        }
        axios
            .put(process.env.REACT_APP_URL + "empresa/evaluarUsuario", null, params)
            .then((res) => {
                //if(!props.esModificar) 
                cambiarEmpresa(empresaId, tipo, 1);
                if (tipo) {
                    toast.dismiss();
                    toastSuccess("Usuario aprobado")
                    document.getElementById(idBoton).classList.remove("pointer-events-none");
                }
                else
                    toastSuccess("Usuario desaprobado")

            })
            .catch(function (error) {
                if (tipo) {
                    toast.dismiss();
                    document.getElementById(idBoton).classList.remove("pointer-events-none");
                }
                toastError(handleError(error))

            })

    }

    function eliminarEvento(id) {
        const params = {
            params: {
                id: id
            }
        }
        axios
            .delete(process.env.REACT_APP_URL + 'evento', params)
            .then((res) => {
                cambiarEvento(id, 0);
                toastSuccess("Evento eliminado");
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
    }

    function mostrarInscriptos() {
        props.setNombreBuscar('')
        document.getElementById("buscarText").value = ''
        document.getElementById("containerInscriptos").classList.add("transform-none");
        document.getElementById("txt-nuevo-evento").classList.add("d-none");
        document.getElementById("txt-cerrar").classList.remove("d-none");
        document.getElementById("btnCrearEvento").classList.add("bg-color-cerrar");
    }

    function mostrarEditar() {
        props.setNombreBuscar('')
        document.getElementById("buscarText").value = ''
        document.getElementById("containerCrear").classList.add("transform-none");
        document.getElementById("txt-nuevo-evento").classList.add("d-none");
        document.getElementById("txt-cerrar").classList.remove("d-none");
        document.getElementById("btnCrearEvento").classList.add("bg-color-cerrar");
    }

    const [mostrarImprimir, setMostrarImprimir] = useState(false);

    const imprimir = (paraEmpresas) => {
        setEsParaEmpresas(paraEmpresas);
        setMostrarImprimir(true);

    };

    const handleImprimirReady = () => {
        setTimeout(() => {
            window.print();
            setMostrarImprimir(false);
        }, 100);
    };

    return (
        <>
            {props.seccion === "crearEvento" ?
                <>
                    <CrearEventoN cambiarEvento={cambiarEvento} nombreBuscar={props.nombreBuscar} setNombreBuscar={props.setNombreBuscar}
                        evento={evento} setPerfil={setPerfil} setIdElemSeleccionado={setIdElemSeleccionado} />
                    <EmpresasInscriptas evento={evento} funciones={{
                        setPerfil: setPerfil, setInscripcion: setInscripcion,
                        setIdElemSeleccionado: setIdElemSeleccionado, setEmpresa: setEmpresa
                    }} nombreBuscar={props.nombreBuscar} />
                    {evento.permiteReuniones && <ModalAgregarMesa inscripcion={inscripcion} empresa={empresa} evento={evento} />}
                </>
                : (
                    <>
                        {props.seccion === "crearReunion" && (
                            <>
                                <CrearReunion evento={evento.id} cambiarReuniones={cambiarEvento} empresas={empresasRonda} horarios={horariosRonda} />
                                {mostrarImprimir && (<Imprimir eventoActual={evento} reuniones={elementos} esTodas={true} esParaEmpresas={esParaEmpresas}
                                    onReady={handleImprimirReady} />)}
                            </>
                        )}
                        < FiltrosAdmin itemsFiltro={itemsFiltro} />
                    </>
                )
            }
            <div className={'container-fluid bg-white rounded-4 textoTablas tabla position-relative mx-0 mx-sm-auto ' + (props.seccion === "crearReunion" ? 'crearReunion' : '')} id='tabla' >
                <div className='row encabezadosTablas py-3 px-sm-3 px-0 bordeTablas align-items-center ocultarMobile'>
                    {props.seccion === "aprobarEmpresa" ? (
                        <>
                            <div className='col-4 '>
                                Empresa
                            </div>
                            <div className='col-2 text-center ocultar740'>
                                Mora
                            </div>
                            <div className='col-2 text-center col-740-3 ocultar-901-680'>
                                Estado
                            </div>
                            <div className='col text-center'>
                            </div>
                        </>
                    ) : props.seccion === "crearReunion" ? (
                        <>
                            <div className='col-6 '>
                                Empresas
                            </div>
                            {estadoReunion === "0" ? (
                                <>
                                    <div className='col-2 text-center'>{/* ocultar740*/}
                                        Mesa
                                    </div>
                                    <div className='col-3 text-center  '>{/*col-740-3 ocultar-901-680*/}
                                        Horarios
                                    </div>
                                    <div className='col-1 text-center px-0'>
                                        <div id="dropdownImprimirFixedAdmin" class="dropdown d-flex align-items-center" >
                                            <div className='logoImprimir  logoImprimirEmpresasInscriptas d-inline-block mx-auto' alt="" data-bs-toggle="dropdown" aria-expanded="false" />

                                            <ul class="dropdown-menu rounded-3">
                                                <li>
                                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado me-3 "
                                                        onClick={() => imprimir(true)}>
                                                        Imprimir para empresas
                                                    </button>
                                                    <button class="btn text-white colorPrincipal bold-botones btn-cuadrado"
                                                        onClick={() => imprimir(false)}>
                                                        Imprimir para administrador
                                                    </button>
                                                </li>

                                            </ul>
                                        </div >
                                    </div>
                                </>
                            ) :
                                <></>}
                        </>
                    ) :
                        <>
                            <div className='col'>
                                Evento
                            </div>
                            <div className='col text-center ocultar-901-750'>
                                Fecha
                            </div>
                            <div className='col text-center ocultar660'>
                                Horarios
                            </div>
                            <div className='col-sm-3 col-660'>

                            </div>
                        </>
                    }

                </div>
                {mostrarLoader ?
                    <LoaderTabla />
                    :
                    <div className='alturaScrollTabla scrollAdmin scrollArea px-3 px-sm-0 '>
                        {elementos.length !== 0 ?

                            elementos.map(function (elem, i) {
                                return (
                                    props.seccion !== "aprobarEmpresa" || mostrarEmpresa(elem) ?
                                        <div id={'idElem' + i} className='row py-3 px-0 px-sm-3 bordeTablas align-items-center mx-0 marginTabla itemsTabla' >
                                            {props.seccion === "aprobarEmpresa" ? (
                                                <>
                                                    <div className='col-sm-4 col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                                                        {elem.nombre}
                                                    </div>
                                                    <div className='col-3 col-sm-2 text-center col-rubro ocultar740 ocultar392'>
                                                        <div className='ocultarMobile'>{elem.estaEnMora ? "Si" : "No"}</div>
                                                        <div className='mostrarMobile d-none'>{elem.estaEnMora ? "Con Mora" : "Sin Mora"}</div>
                                                    </div>
                                                    <div className='col-4 col-sm-2 px-0 text-center col-rubro col-740-3 col-392 ocultar-901-680'>
                                                        {elem.estaAprobado ? "Aprobado" : elem.estaAprobado === null ? "Pendiente" : "Desaprobado"}
                                                    </div>
                                                    <div className='col col-sm text-end col-rubro text-center-901-400'>
                                                        {!elem.estaAprobado || elem.estaAprobado === null ?
                                                            <img id={"aprobar" + i} className='cursor-pointer img-blanco-mobile' src={logoAprobar} alt="" onClick={() => evaluarUsuario(elem.id, true, "aprobar" + i)} />
                                                            :
                                                            <></>
                                                        }
                                                        {elem.estaAprobado || elem.estaAprobado === null ?
                                                            <img className={'ms-3 cursor-pointer img-blanco-mobile' + (elem.estaAprobado ? " logoDesaprobar" : "")} src={logoDesaprobar} alt="" onClick={() => setIdElemSeleccionado(elem.id)} data-bs-toggle="modal"
                                                                data-bs-target="#desaprobarUsuario" />
                                                            :
                                                            <></>
                                                        }
                                                        <img className='ms-3 cursor-pointer img-blanco-mobile' src={logoVerPerfil} alt="" data-bs-toggle="modal"
                                                            data-bs-target="#modalPerfil" onClick={() => { setPerfil(elem); setIdElemSeleccionado(elem.id) }} />
                                                        <div id="dropdownConfigFixedAdmin" class="dropdown d-inline-block " >
                                                            <img className='ms-3 cursor-pointer img-blanco-mobile' src={logoEditar} alt="" data-bs-toggle="dropdown" aria-expanded="false" />

                                                            <ul class="dropdown-menu rounded-3">
                                                                <li>
                                                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado me-3  btn-verperfil-empresas "
                                                                        onClick={() => modificarMora(elem.id, !elem.estaEnMora)}>
                                                                        {elem.estaEnMora ? 'Remover Mora' : 'Agregar Mora'}
                                                                    </button>

                                                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal"
                                                                        data-bs-target="#modalCambiarUnion" onClick={() => setPerfil(elem)}>Modificar Unión</button>

                                                                    <div className="cruzMenuConfiguracion" alt="" />

                                                                </li>

                                                            </ul>
                                                        </div >
                                                    </div>
                                                </>
                                            ) : props.seccion === "crearEvento" ? (
                                                <>
                                                    <div className='col-sm col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                                                        {elem.nombre}
                                                    </div>
                                                    <div className='col text-center ocultar-901-750 ocultar-901-450'>
                                                        {elem.fecha}
                                                    </div>
                                                    <div className='col text-center ocultar660'>
                                                        {elem.horaInicio + " / " + elem.horaFin}
                                                    </div>
                                                    <div className='text-end col-sm-3 col centrarMobile col-660'>
                                                        <div className='d-inline-block cursor-pointer' onClick={() => { setEvento(elem); mostrarInscriptos() }}><div className='d-inline-block'>{elem.cantInscriptos}</div>
                                                            <img className=' img-blanco-mobile translateY--2px ms-1' src={logoInscriptos} alt="" /></div>
                                                        <img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEditar} alt="" onClick={() => { setEvento(elem); mostrarEditar() }} />
                                                        <img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEliminar} alt="" data-bs-toggle="modal"
                                                            data-bs-target="#eliminarEvento" onClick={() => setIdElemSeleccionado(elem.id)} />

                                                    </div>
                                                </>
                                            ) : props.seccion === "crearReunion" ? (
                                                <>
                                                    <div className='col-sm-6 col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                                                        {estadoReunion === "1" ?
                                                            elem.empresa?.nombre + " -> " + elem.empresaInteres?.nombre
                                                            : elem.empresas?.[0]?.nombre + " - " + elem.empresas?.[1]?.nombre
                                                        }
                                                    </div>
                                                    {estadoReunion === "0" ? (
                                                        <>
                                                            <div className='col-6 text-center col-sm-2'>
                                                                <span className='d-inline-block-mobile d-none me-2'>Mesa:</span>{elem.mesa}
                                                            </div>
                                                            <div className='col-6 col-sm-3 text-center'>
                                                                {elem.horaInicio + " / " + elem.horaFin}
                                                            </div>
                                                            <div className='text-end col-sm-3 col centrarMobile col-660'>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className='col-6 text-center'>
                                                                {estadoReunion === "1" ? 'Pendiente' : 'No concretada'}
                                                            </div>
                                                        </>
                                                    )}

                                                    {/*<img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEditar} alt="" />
                                                        <img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEliminar} alt="" data-bs-toggle="modal"
                                                            data-bs-target="#eliminarEvento" onClick={() => setIdElemSeleccionado(elem.id)} />
                                                        <img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEliminar} alt="" data-bs-toggle="modal"
                                                            data-bs-target="#eliminarEvento" onClick={() => setIdElemSeleccionado(elem.id)} />*/}


                                                </>
                                            )
                                                : (
                                                    <>
                                                    </>
                                                )
                                            }
                                        </div>

                                        :
                                        <></>

                                )
                            })
                            :
                            <>
                                {props.seccion === "crearEvento" ? (
                                    <p className='text-center mt-4'>No se encontraron eventos</p>
                                ) : props.seccion === "crearReunion" ? (
                                    < p className='text-center mt-4'>No se encontraron reuniones</p>
                                ) : (
                                    <p className='text-center mt-4'>No se encontraron empresas</p>
                                )
                                }
                            </>
                        }
                    </div>
                }
            </div >
            <ModalPerfil perfil={perfil} modificarMora={modificarMora} evaluarUsuario={evaluarUsuario}
                setPerfil={setPerfil} esAdmin={true} />
            {/*<ModalExisteCuit />*/}
            <ModalCambiarUnion perfil={perfil} cambiarEmpresa={cambiarEmpresa} />
            {
                props.seccion === "crearEvento" ?
                    <DeseaCancelar funcionAdmin={() => eliminarEvento(idElemSeleccionado)} id={'eliminarEvento'} />
                    :
                    <DeseaCancelar funcionAdmin={() => evaluarUsuario(idElemSeleccionado, false)} id={'desaprobarUsuario'} />
            }
        </>
    );
}


export default TablaAdmin;